import api from 'api';

export const loadActivities = api('GET /api/kpi/fields/activities');

export const loadMetrics = api('GET /api/kpi/fields/metrics');

export const loadTraffics = api('GET /api/kpi/fields/traffics');

export const loadGenres = api('GET /api/kpi/fields/genres');

export const loadApplications = api('GET /api/kpi/fields/applications');

export const loadNetworks = api('GET /api/kpi/fields/networks');

export const loadPlatforms = api('GET /api/kpi/fields/platforms');

export const loadCountries = api('GET /api/kpi/fields/countries');

export const loadRegistrations = api('GET /api/kpi/fields/registrations');

export const loadFrauds = api('GET /api/kpi/fields/frauds');
